<template>
	<Panel :title="title" icon="globe-americas" url="/quinielas-publicas" class="quinielas-publicas">
		<p class="panel-block" style="border: 0" v-show="quinielas_publicas.length == 0">No hay Quinielas en este momento..</p>
		<transition-group name="card">
			<router-link :to="'/ver-quiniela/' + quiniela.id" v-for="quiniela in quinielas_publicas" :key="quiniela.id+'-'+quiniela.jugadores_count" class="panel-block" style="display: block">
				
				<!-- <div class="item-quiniela">
					<div class="nombre-quiniela"><p>{{ quiniela.nombre }}</p></div>
					<div class="info-quiniela">
						<span :title="quiniela.jugadores_count + ' jugador(es)'" class="tag is-dark">
							<span class="icon"><font-awesome-icon icon="users" /></span>
							<span>{{ quiniela.jugadores_count }}</span>

							<span class="icon" :title="quiniela.apuesta + ' puntos para participar'" >
								<font-awesome-icon class="icon" icon="coins"/> 
							</span>
							<span>{{ quiniela.apuesta }}</span>
						</span>
					</div>
				</div> -->

				<div class="level is-mobile">
					<div class="level-left">
						<div class="level-item nombre-quiniela" :class="{'disabled' : quiniela.status == 'terminada'}">
							<span class="truncate">{{ quiniela.nombre }}</span>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">

							<span :title="quiniela.jugadores_count + ' jugador(es)'" class="tag is-dark">
								<span class="icon"><font-awesome-icon icon="users" /></span>
								<span>{{ quiniela.jugadores_count }}</span>

								<span class="icon" :title="quiniela.apuesta + ' puntos para participar'" >
									<font-awesome-icon class="icon" icon="coins"/> 
								</span>
								<span>{{ quiniela.apuesta }}</span>
							</span>
						</div>
					</div>
				</div>
			</router-link>
		</transition-group>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import { mapState } from 'vuex'

	export default {
		components: { Panel },
		props: {
			title: {
				type: String,
				required: true,
			}
		},
		name: 'QuinielasPublicas',
		created(){
			this.$store.dispatch('quinielas/fetchQuinielasPublicas')
		},
		data() {
			return {

			};
		},
		computed: mapState('quinielas',['quinielas_publicas'])
	};
</script>

<style lang="css" scoped>
.item-quiniela{
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.nombre-quiniela{
	min-width: 0;
	flex-basis: 50%;
}
.nombre-quiniela p{
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.info-quiniela{
	min-width: 0;
	flex-basis: 50%;
	margin-left: auto;
}
</style>
